import type { StandingRow } from '../api';

/**
 * Whether the table is worth posting yet.
 *
 * IN ITS OWN FILE, and that is the whole reason it moved out of `table.ts`.
 *
 * The standings screen has to ask this question to decide whether to offer the
 * share button at all — and asking it used to mean importing `table.ts`, which
 * pulls in the card renderer, the texture generator and the canvas helpers:
 * about 100 KB of poster machinery, loaded by every visitor looking at the
 * league table on their phone, so that a button could be hidden.
 *
 * A predicate with no dependencies can be asked cheaply, and the poster code
 * then loads only when somebody actually shares something.
 */
export function hasPostableTable(standings: StandingRow[]): boolean {
  // Two sides have to have played. A table of noughts ranks nobody.
  return standings.filter((row) => row.played > 0).length >= 2;
}
